import { createTypedReducerWithImmer } from "@insite/client-framework/Common/CreateTypedReducer";
import DepartmentState from "@tCooneyBrothers/Store/Data/Department/DepartmentState";
import { Draft } from "immer";

import { DepartmentModel } from "@tCooneyBrothers/ApiModels";

const initialState: DepartmentState = {
    isLoading: false,
    value: [
        {
            id: "0",
            description: "Select Department",
        },
    ],
};

const reducer = {
    "Data/Department/BeginLoadDepartments": (draft: Draft<DepartmentState>) => {
        draft = {
            isLoading: true,
        };
    },
    "Data/Department/CompleteLoadDepartments": (
        draft: Draft<DepartmentState>,
        action: { result: DepartmentModel[] },
    ) => {
        draft = {
            isLoading: false,
            value: initialState.value?.concat(action.result),
        };
        return draft;
    },
};

export default createTypedReducerWithImmer(initialState, reducer);
